export default "__VITE_ASSET__BqP0ZX2I__"